<template>
    <div class="main-wrapper background--b2b">
        <div class="grid">
            <div class="header header--subpage">
                <button style="border-radius: 0; border: none; background-color: transparent;" @click="$emit('home')"><img src="/assets/icons/mimi-logo.svg"></button>
                <button class="btn--back" @click="$emit('back')">Back</button>
            </div>
            <div class="content-wrapper--subpage">
                <div class="content--b2b">
                    <div>
                        <h1>Join the mission <br>of better and healthier audio!</h1>
                        <div class="contact-wrapper">
                            <div class="contact__copy">
                                <p>Book a demo at IFA or leave your contact details and our team will reach out to organise a time to meet.</p>
                            </div>
                            <div class="contact__image qr-code">
                                <img src="/assets/images/ifa-2022-mimi-hearing.png">
                                <p class="caption">Scan or visit info.mimi.io/ifa-2022-mimi-hearing</p>
                            </div>
                        </div>
                    </div>        
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'B2B'
}
</script>

<style>

.background--b2b {
 background-image: url("/assets/images/background--b2b.jpg");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.content-wrapper--subpage {
  padding: 2rem;
  color: #333;
  height: 100%;
}

.content--b2b {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100%;
}

.content--b2b h1 {
  font-size: 2.25rem;
  font-weight: 400;
  margin-bottom: 1rem;
}

.content--b2b p {
  font-size: 1rem;
  line-height: 1.5rem;
  max-width: 45%;
  margin: 0 auto 2rem auto;
}

.content--b2b button {
    font-size: 1.25rem;
    height: 3rem;
    padding: 0 1.5rem;
    border-radius: 2rem;
    background-color: #333;
    color: #FFF;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: background-color 0.3s;
}

.content--b2b button:active {
  background-color: #7E47FF;
  transition: background-color 0.3s;
}

.contact__image img {
    width: 100%;
    height: auto;
}

.qr-code img {
    width: 16rem;
    height: 16rem;
}

.contact__image .caption {
    font-size: 0.75rem;
    font-weight: 600;
}

.header--subpage {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header--subpage button {
    font-size: 1rem;
    height: 3.5rem;
    border-radius: 3rem;
    font-weight: 500;
    background-color: transparent;
    color: #FFF;
    border: 1px solid #FFF;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.header--subpage button svg {
    margin-right: 0.5rem;
}

</style>